import React from 'react';
import cx from '../../../../utils/cx';
import { Slider, ToggleSwitchContainer } from './styled';

interface IToggleSwitchProps {
    checked?: boolean;
    onChange?: (isChecked: boolean) => void;
    small?: boolean;
}

const ToggleSwitch = (props: IToggleSwitchProps) => {

    const [isChecked, setIsChecked] = React.useState<boolean>(props.checked ?? true);

    const onChange = React.useCallback((e: any) => {
        if (props.onChange) {
            props.onChange(!isChecked);
        }
        setIsChecked(!isChecked);
    }, [props.onChange, isChecked]);

    React.useEffect(() => {
        if (props.checked !== undefined) {
            setIsChecked(props.checked);
        }
    }, [props.checked]);

    return (
        <ToggleSwitchContainer onClick={onChange} className={cx({ smallSize: props.small })}>
            <input type="checkbox" checked={isChecked}></input>
            <Slider className='slider round' />
        </ToggleSwitchContainer>
    )
}

export default ToggleSwitch;